import React, { Children } from 'react';
import { Layout } from '../components/layout/Layout';
import { motion } from 'framer-motion';
import { Heart, Mail, DollarSign, CreditCard, Smartphone } from 'lucide-react';
export function GivePage() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 24
      }
    }
  };
  return <Layout data-id="element-752">
      {/* Hero Section */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-753">
        <div className="absolute inset-0 opacity-20" data-id="element-754">
          <img src="https://images.unsplash.com/photo-1438232992991-995b7058bbb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Worship Background" className="w-full h-full object-cover" data-id="element-755" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44] via-[#0A1F44]/70 to-[#0A1F44]" data-id="element-756" />

        <div className="container-custom relative z-10" data-id="element-757">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-6xl font-serif font-bold mb-6" data-id="element-758">
            Give
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-759">
            Your generosity helps us continue our mission to reach people with
            the love of Christ and serve our community.
          </motion.p>
        </div>
      </div>

      {/* Ways to Give Section */}
      <section className="py-24 bg-[#F5F7FA]" data-id="element-760">
        <div className="container-custom" data-id="element-761">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-762">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0A1F44] mb-4" data-id="element-763">
              Ways to Give
            </h2>
            <div className="h-1 w-20 bg-[#fc0719] mx-auto rounded-full" data-id="element-764" />
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-765">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-2xl p-8 text-center shadow-lg border-t-4 border-[#00D632] flex flex-col items-center justify-center min-h-[240px]" data-id="element-766">
              <div className="w-20 h-20 bg-[#00D632]/5 rounded-full flex items-center justify-center mb-6" data-id="element-767">
                <img src="https://upload.wikimedia.org/wikipedia/commons/c/c5/Square_Cash_app_logo.svg" alt="CashApp Logo" className="w-12 h-12 object-contain" data-id="element-768" />
              </div>
              <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-769">CashApp</h3>
              <p className="text-lg font-bold text-gray-700 bg-gray-50 px-4 py-2 rounded-lg w-full" data-id="element-770">
                $Thehousehold
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-2xl p-8 text-center shadow-lg border-t-4 border-[#003087] flex flex-col items-center justify-center min-h-[240px]" data-id="element-771">
              <div className="w-20 h-20 bg-[#003087]/5 rounded-full flex items-center justify-center mb-6" data-id="element-772">
                <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal Logo" className="w-16 h-16 object-contain" data-id="element-773" />
              </div>
              <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-774">PayPal</h3>
              <p className="text-sm font-bold text-gray-700 bg-gray-50 px-4 py-3 rounded-lg w-full break-all" data-id="element-775">
                paypal.me/thehousehold
              </p>
            </motion.div>

            <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 text-center shadow-lg border-t-4 border-[#6D1ED4] flex flex-col items-center justify-center min-h-[240px]" data-id="element-776">
              <div className="w-20 h-20 rounded-full bg-[#6D1ED4]/5 flex items-center justify-center mb-6 border-2 border-[#6D1ED4]" data-id="element-777">
                <img src="https://cdn.magicpatterns.com/uploads/ikEUnZjScHqoTn3V6Dbb7E/pasted-image.png" alt="Zelle Logo" className="w-16 h-16 object-contain" data-id="element-778" />
              </div>
              <h3 className="text-xl font-bold text-[#0A1F44] mb-4" data-id="element-779">Zelle</h3>
              <div className="text-sm font-bold text-gray-700 bg-gray-50 px-4 py-3 rounded-lg w-full space-y-1" data-id="element-780">
                <p className="break-all" data-id="element-781">householdchurch1@gmail.com</p>
                <p className="text-gray-400 font-medium text-xs uppercase" data-id="element-782">
                  or
                </p>
                <p data-id="element-783">301-996-6907</p>
                <p data-id="element-784">+1 (832) 447-7348</p>
              </div>
            </motion.div>

            <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 text-center shadow-lg border-t-4 border-[#fc0719] flex flex-col items-center justify-center min-h-[240px]" data-id="element-785">
              <div className="w-16 h-16 bg-[#fc0719]/10 rounded-full flex items-center justify-center text-[#fc0719] mb-6" data-id="element-786">
                <Mail className="w-8 h-8" strokeWidth={2} data-id="element-787" />
              </div>
              <h3 className="text-xl font-bold text-[#0A1F44] mb-4" data-id="element-788">Mail</h3>
              <div className="text-sm text-gray-700 bg-gray-50 px-4 py-3 rounded-lg w-full" data-id="element-789">
                <p className="font-bold text-[#0A1F44]" data-id="element-790">TheHousehold</p>
                <p data-id="element-791">1221 Caraway CT; #1090</p>
                <p className="mb-2" data-id="element-792">Largo MD 20774</p>
                <p className="text-xs text-gray-500 leading-tight" data-id="element-793">
                  Send Check or Money order to the Address Above Via mailing.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-24 bg-[#0A1F44] text-white text-center relative z-10" data-id="element-794">
        <div className="container-custom" data-id="element-795">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-796">
            <Heart className="w-12 h-12 mx-auto mb-8 text-[#fc0719]" data-id="element-797" />
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-798">
              Your Generosity Makes a Difference
            </h2>
            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="block mt-8 text-[#fc0719] font-medium not-italic uppercase tracking-widest text-sm md:text-base" data-id="element-799">
              — 2 Corinthians 9:7
            </motion.p>
          </motion.div>
        </div>
      </section>
    </Layout>;
}